import DealsMain from 'components/featured/Deals';
import { useParams } from 'react-router-dom';

export const Deals = () => {
  const params = useParams();
  const userId = params.id;

  return (
    <div>
      <DealsMain userId={userId} />
    </div>
  );
};
